(function () {
  'use strict';

  var KEY = 'geartub_wishlist';

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    syncWishlist();
    renderWishlistPage();
  }

  function updateCount(items) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.style.display = items.length ? 'inline' : 'none';
    });
  }

  function syncWishlist() {
    var items = getItems();

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = items.some(function (item) {
        return item.handle === btn.dataset.productHandle;
      });

      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });

    updateCount(items);
  }

  function toggleWishlist(btn) {
    var items = getItems();
    var handle = btn.dataset.productHandle;

    if (!handle) return;

    var index = items.findIndex(function (item) {
      return item.handle === handle;
    });

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push({
        handle: handle,
        id: btn.dataset.productId || '',
        title: btn.dataset.productTitle || '',
        url: btn.dataset.productUrl || '#',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || ''
      });
    }

    saveItems(items);
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');

    if (!grid) return;

    var items = getItems();

    if (empty) {
      empty.style.display = items.length ? 'none' : 'block';
    }

    grid.innerHTML = items.map(function (item) {
      return (
        '<div class="one-fourth column medium-down--one-half small-down--one-half thumbnail">' +
          '<a href="' + item.url + '" class="thumbnail__link">' +
            '<div class="thumbnail__image">' +
              '<div class="image__container">' +
                '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
              '</div>' +
              '<button type="button" class="wishlist-page-remove is-active" data-wishlist-remove="' + item.handle + '" aria-label="Remove from wishlist"></button>' +
            '</div>' +
            '<div class="thumbnail__content thumbnail__content--bottom">' +
              '<div class="product-thumbnail__title-container">' +
                '<span class="thumbnail__title">' + item.title + '</span>' +
              '</div>' +
              '<div class="product-thumbnail__info-container">' +
                '<span class="thumbnail__price"><span class="money">' + item.price + '</span></span>' +
              '</div>' +
            '</div>' +
          '</a>' +
        '</div>'
      );
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    var removeBtn = e.target.closest('[data-wishlist-remove]');

    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      toggleWishlist(toggleBtn);
      return false;
    }

    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      saveItems(getItems().filter(function (item) {
        return item.handle !== removeBtn.dataset.wishlistRemove;
      }));

      return false;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    syncWishlist();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    syncWishlist();
    renderWishlistPage();
  });
})();